const oneForAll = `${process.env.resourceUrl}images/ar/home_1forall.webp`
const home_air2_mobile = `${process.env.resourceUrl}images/ar/home_air2_product.jpg`
const home_eva = `${process.env.resourceUrl}images/ar/home_EVA.webp`
const home_ada = `${process.env.resourceUrl}images/ar/home_ADA.webp`
const stickersVd = `${process.env.resourceUrl}video/home_stickers.mp4`
const light_question_pc = `${process.env.resourceUrl}images/home/light/light_question_pc.webp`
const light_question_mobile = `${process.env.resourceUrl}images/home/light/light_question_mobile.webp`


const jp_love_text = `${process.env.resourceUrl}images/home/love/love_text.webp`
const jp_love_girl = `${process.env.resourceUrl}images/home/love/love_girl.webp`
const jp_love_boy = `${process.env.resourceUrl}images/home/love/love_boy.webp`
const jp_love_boy_mobile = `${process.env.resourceUrl}images/home/love/love_boy_mobile.webp`
const air2_pink_logo = `${process.env.resourceUrl}images/home/love/air2_pink_logo.webp`

const home_beampro = `${process.env.resourceUrl}images/home/beampro_pc.jpg`
const home_beampro_mobile = `${process.env.resourceUrl}images/home/beampro_mobile.jpg`
const home_air2ultra = `${process.env.resourceUrl}images/home/air2ultra_pc.jpg`
const home_air2ultra_mobile  = `${process.env.resourceUrl}images/home/air2ultra_mobile.jpg`
const home_air2pro = `${process.env.resourceUrl}images/home/air2pro_pc.jpg`
const home_air2pro_mobile  = `${process.env.resourceUrl}images/home/air2pro_mobile.jpg`
const air_pc = `${process.env.resourceUrl}images/home/air_pc.jpg`
const air_mobile  = `${process.env.resourceUrl}images/home/air_mobile.jpg`
const beam_pc = `${process.env.resourceUrl}images/home/beam_pc.jpg`
const beam_mobile  = `${process.env.resourceUrl}images/home/beam_mobile.jpg`
const adapter_pc = `${process.env.resourceUrl}images/home/adapter_pc.webp`
const adapter_mobile  = `${process.env.resourceUrl}images/home/adapter_mobile.webp`
const home_hub = `${process.env.resourceUrl}images/home/hub_pc.webp`
const home_hub_mobile  = `${process.env.resourceUrl}images/home/hub_mobile.webp`
const home_video = `${process.env.resourceUrl}video/home_video1.mp4`
const home_video2 = `${process.env.resourceUrl}video/home_video2.mp4`
const home_video2_mobile = `${process.env.resourceUrl}video/home_video2_mobile.mp4`
const jpoff_bg = `${process.env.resourceUrl}images/home/jp_15offbg_pc.jpg`
const jpoff_bg_mobile = `${process.env.resourceUrl}images/home/jp_15offbg_mobile.jpg`
const One_Desktop = `${process.env.resourceUrl}images/home/One_Desktop.webp`
const One_Mobile = `${process.env.resourceUrl}images/home/One_Mobile.webp`
const OnePro_Desktop = `${process.env.resourceUrl}images/home/OnePro_Desktop.webp`
const OnePro_Mobile = `${process.env.resourceUrl}images/home/OnePro_Mobile.webp`
const Dog_Desktop = `${process.env.resourceUrl}images/home/Dog_Desktop.mp4`
const Dog_mobile = `${process.env.resourceUrl}images/home/Dog_mobile.mp4`

import glowBottom from "./glow_bottom.svg"
import glowTop from "./glow_top.svg"
import glowLeft from "./glow_left.svg"
import glowRight from "./glow_right.svg"


const home_One_Desktop = `${process.env.resourceUrl}images/home/home_One_Desktop.webp`
const home_One_Mobile = `${process.env.resourceUrl}images/home/home_One_Mobile.webp`
const home_OnePro_Desktop = `${process.env.resourceUrl}images/home/home_OnePro_Desktop.webp`
const home_OnePro_Mobile = `${process.env.resourceUrl}images/home/home_OnePro_Mobile.webp`
const home_Eye_Desktop = `${process.env.resourceUrl}images/home/home_Eye_Desktop.webp`
const home_Eye_Mobile = `${process.env.resourceUrl}images/home/home_Eye_Mobile.webp`
const home_OneVideo_Desktop = `${process.env.resourceUrl}images/home/home_OneVideo_Desktop.mp4`
const home_OneVideo_Mobile = `${process.env.resourceUrl}images/home/home_OneVideo_Mobile.mp4`
const home_Air2Ultra_Desktop = `${process.env.resourceUrl}images/home/home_Air2Ultra_Desktop.webp`
const home_Air2Ultra_Mobile = `${process.env.resourceUrl}images/home/home_Air2Ultra_Mobile.webp`
const home_BeamPro_Desktop = `${process.env.resourceUrl}images/home/home_BeamPro_Desktop.webp`
const home_BeamPro_Mobile = `${process.env.resourceUrl}images/home/home_BeamPro_Mobile.webp`
const home_Air2Pro_Desktop = `${process.env.resourceUrl}images/home/home_Air2Pro_Desktop.webp`
const home_Air2Pro_Mobile = `${process.env.resourceUrl}images/home/home_Air2Pro_Mobile.webp`
const home_Hub_Desktop = `${process.env.resourceUrl}images/home/home_Hub_Desktop.webp`
const home_Hub_Mobile = `${process.env.resourceUrl}images/home/home_Hub_Mobile.webp`
const home_Aura_Desktop = `${process.env.resourceUrl}images/home/home_Aura_Desktop.webp`
const home_Aura_Mobile = `${process.env.resourceUrl}images/home/home_Aura_Mobile.webp`

const menu_Air2 = `${process.env.resourceUrl}images/home/menu_air2.png`
const menu_Air2Pro = `${process.env.resourceUrl}images/home/menu_air2pro.png`
const menu_Air2Ultra = `${process.env.resourceUrl}images/home/menu_air2ultra.png`
const menu_BeamPro = `${process.env.resourceUrl}images/home/menu_BeamPro.png`
const menu_Eye = `${process.env.resourceUrl}images/home/menu_Eye.png`
const menu_Hub = `${process.env.resourceUrl}images/home/menu_Hub.png`
const menu_One = `${process.env.resourceUrl}images/home/menu_One.png`
const menu_OnePro = `${process.env.resourceUrl}images/home/menu_OnePro.png`
const home_herosection_BP_Desktop = `${process.env.resourceUrl}images/home/home_herosection_BP_Desktop.webp`
const home_herosection_BP_Mobile = `${process.env.resourceUrl}images/home/home_herosection_BP_Mobile.webp`

import left_Icon from "./left_Icon.svg"
import right_Icon from "./right_Icon.svg"

const Question_Bg_Desktop = `${process.env.resourceUrl}images/home/Question_Bg_Desktop.webp`
const Question_Bg_Mobile = `${process.env.resourceUrl}images/home/Question_Bg_Mobile.webp`
const Compare_BG_Desktop = `${process.env.resourceUrl}images/home/Compare_BG_Desktop.webp`
const Compare_BG_Mobile = `${process.env.resourceUrl}images/home/Compare_BG_Mobile.webp`
const Compare_Present = `${process.env.resourceUrl}images/home/Compare_Present.mp4`
const Compare_Future = `${process.env.resourceUrl}images/home/Compare_Future.mp4`

import Right from "./right.svg"

const Neo_Desktop = `${process.env.resourceUrl}images/home/Neo_Desktop.webp`
const Neo_Mobile = `${process.env.resourceUrl}images/home/Neo_Mobile.webp`
const Fyears_Desktop = `${process.env.resourceUrl}images/home/5years_Desktop.webp`
const Fyears_Mobile = `${process.env.resourceUrl}images/home/5years_Mobile.webp`

const tradein_Desktop = `${process.env.resourceUrl}images/home/tradein_Desktop_0724.jpg`
const tradein_Mobile = `${process.env.resourceUrl}images/home/tradein_Mobile_0724.jpg`

export {
    tradein_Desktop,
    tradein_Mobile,
    Fyears_Desktop,
    Fyears_Mobile,
    Neo_Desktop,
    Neo_Mobile,
    Right,
    Question_Bg_Desktop,
    Question_Bg_Mobile,
    Compare_BG_Desktop,
    Compare_BG_Mobile,
    Compare_Present,
    Compare_Future,
    home_herosection_BP_Desktop,
    home_herosection_BP_Mobile,
    menu_Air2,
    menu_Air2Pro,
    menu_Air2Ultra,
    menu_BeamPro,
    menu_Eye,
    menu_Hub,
    menu_One,
    menu_OnePro,
    home_Air2Pro_Desktop,
    home_Air2Pro_Mobile,
    home_Hub_Desktop,
    home_Hub_Mobile,
    home_Air2Ultra_Desktop,
    home_Air2Ultra_Mobile,
    home_BeamPro_Desktop,
    home_BeamPro_Mobile,
    home_OneVideo_Desktop,
    home_OneVideo_Mobile,
    home_One_Desktop,
    home_One_Mobile,
    home_OnePro_Desktop,
    home_OnePro_Mobile,
    home_Eye_Desktop,
    home_Eye_Mobile,
    home_Aura_Desktop,
    home_Aura_Mobile,
    glowBottom,
    glowTop,
    glowLeft,
    glowRight,
    Dog_Desktop,
    Dog_mobile,
    One_Desktop,
    OnePro_Mobile,
    OnePro_Desktop,
    One_Mobile,
    jpoff_bg,
    jpoff_bg_mobile,
    air_pc,
    air_mobile,
    beam_pc,
    beam_mobile,
    adapter_pc,
    adapter_mobile,
    home_hub,
    home_hub_mobile,
    home_air2pro,
    home_air2pro_mobile,
    home_air2ultra,
    home_air2ultra_mobile,
    home_beampro_mobile,
    home_video,
    home_eva,
    stickersVd,
    home_ada,
    home_air2_mobile,
    oneForAll,
    light_question_pc,
    light_question_mobile,
    jp_love_text,
    jp_love_girl,
    jp_love_boy,
    air2_pink_logo,
    jp_love_boy_mobile,
    home_beampro,
    home_video2,
    home_video2_mobile,
    left_Icon,
    right_Icon
}